import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "./siteConfig";

const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/logo.png`;

/**
 * Head-only SEO: title, description, canonical, OG/Twitter (no visible UI).
 */
export default function PageSeo({
  title,
  description,
  path,
  ogImage = DEFAULT_OG_IMAGE,
}) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const canonical = `${SITE_URL}${normalizedPath}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ChooseRightCareer" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
